<p>customer-view works!</p>
